<template lang="html">
  <NutrientBalanceTable :columns="columns" :details="details" />
</template>

<script>
import NutrientBalanceTable from './NutrientBalanceTable'

export default {
  components: {
    NutrientBalanceTable
  },
  props: {
    details: Object
  },
  computed: {
    columns () {
      return {
        name: 'dlgCert.certificatePreview.nutrientBalance.labels.field',
        area: 'dlgCert.certificatePreview.nutrientBalance.labels.hectareArea',
        supplyFromOrganicFertilization: 'dlgCert.certificatePreview.phosphorusBalance.labels.supplyFromOrganicFertilization',
        supplyFromMineralicFertilization: 'dlgCert.certificatePreview.phosphorusBalance.labels.supplyFromMineralicFertilization',
        withdrawalByCrops: 'dlgCert.certificatePreview.phosphorusBalance.labels.withdrawalByCrops',
        phosphorusBalance: 'dlgCert.certificatePreview.nutrientBalance.labels.phosphorusBalance',
        detailedClassification: 'dlgCert.certificatePreview.nutrientBalance.labels.classification'
      }
    }
  }
}
</script>

<style lang="scss" module>
</style>
